export const WEATHER_QUERY = `
  query getForecast($location_id: ID!, $unit: TemperatureUnit) {
    forecast(location_id: $location_id, unit: $unit) {
      dailyForecast {
        condition
        date
        iconUrl
        maxTemp
        minTemp
      }
      id
      selectedDayHourly {
        temp
        time
      }
      unit
    }
  }
`;